module.exports = __webpack_public_path__ + "img/trading1.85f9869e.svg";